import React, { useEffect } from 'react';
import Dither from '../components/Dither';
import { Link } from 'react-router-dom';

export default function Legal() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const legalStyles = `
        .legal-container {
            max-width: 800px;
            margin: 0 auto;
            padding: 8rem 2rem;
        }
        .legal-header {
            font-family: 'Heading Now', sans-serif;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: -0.05em;
            line-height: 0.85;
            margin-bottom: 4rem;
        }
        .legal-section {
            margin-bottom: 4rem;
        }
        .legal-title {
            font-family: 'Heading Now', sans-serif;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: -0.02em;
            color: var(--accent, #38bdf8);
            margin-bottom: 1.5rem;
            font-size: 1.5rem;
        }
        .legal-text {
            font-family: 'SF Mono', 'Fira Code', monospace;
            font-size: 0.85rem;
            line-height: 1.8;
            color: rgba(255, 255, 255, 0.6);
            text-transform: uppercase;
        }
        .legal-date {
            font-family: 'SF Mono', monospace;
            font-size: 0.7rem;
            color: rgba(255, 255, 255, 0.3);
            margin-bottom: 2rem;
            display: block;
        }
    `;

    return (
        <main className="w-full min-h-screen bg-background relative z-10 overflow-hidden text-white pattern-dots">
            <style>{legalStyles}</style>

            {/* Background */}
            <div className="fixed inset-0 z-0 opacity-20 pointer-events-none mix-blend-screen overflow-hidden">
                <Dither
                    waveColor={[20/255, 60/255, 90/255]} 
                    colorNum={4}
                    waveAmplitude={0.5}
                    waveFrequency={1.5}
                    waveSpeed={0.02}
                />
            </div>

            <div className="relative z-10 legal-container">
                <Link to="/" className="font-mono text-[9px] font-bold uppercase tracking-[0.2em] text-white/50 hover:text-white transition-all duration-300 flex items-center gap-3 bg-white/5 px-4 py-2 border border-transparent shadow-none group mb-20 w-fit">
                    <span className="w-6 h-px bg-white/30 group-hover:w-8 group-hover:bg-white transition-all duration-300"></span>
                    SYS_RETURN_HOME
                </Link>

                <h1 className="legal-header text-7xl md:text-9xl">
                    LEGAL<br />PROTOCOL
                </h1>
                
                <span className="legal-date">REVISION_ID: 2026.03.19.V1</span>

                <section className="legal-section">
                    <h2 className="legal-title">PRIVACY_POLICY</h2>
                    <div className="legal-text">
                        <p className="mb-4">
                            AT MORA TADEO SYSTEMS, PRIVACY IS NOT AN AFTERTHOUGHT; IT IS AN ARCHITECTURAL FOUNDATION. WE DO NOT COLLECT, SURVEIL, OR MONETIZE YOUR DATA.
                        </p>
                        <p className="mb-4">
                            ANY DATA INPUT INTO OUR OFFLINE-FIRST APPLICATIONS REMAINS ON YOUR DEVICE. NO REMOTE TRACKING. NO THIRD-PARTY ANALYTICS. ZERO DATA PERSISTED ON CLOUD INFRASTRUCTURE UNLESS EXPLICITLY INITIATED BY THE USER FOR SYNCHRONIZATION PURPOSES.
                        </p>
                        <p>
                            YOUR DIGITAL FOOTPRINT IS YOURS TO COMMAND. WE PROVIDE THE TOOLS; YOU RETAIN COMPLETE DATA SOVEREIGNTY.
                        </p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2 className="legal-title">TERMS_OF_ENGAGEMENT</h2>
                    <div className="legal-text">
                        <p className="mb-4">
                            BY ACCESSING MORA TADEO SYSTEMS OR UTILIZING OUR DIGITAL ARTIFACTS, YOU AGREE TO THE FOLLOWING PROTOCOLS:
                        </p>
                        <ul className="list-none space-y-4">
                            <li>01. SYSTEMS ARE PROVIDED "AS-IS" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED.</li>
                            <li>02. WE RESERVE THE RIGHT TO EVOLVE, DEPRECATE, OR REFACTOR ANY MODULE OR INTERFACE AT OUR DISCRETION.</li>
                            <li>03. UNAUTHORIZED REVERSE ENGINEERING OF PROPRIETARY LOGIC IS PROHIBITED.</li>
                            <li>04. USERS ARE RESPONSIBLE FOR MAINTAINING THE SECURITY OF THEIR OWN LOCAL DATA ENVIRONMENTS.</li>
                        </ul>
                    </div>
                </section>

                <section className="legal-section">
                    <h2 className="legal-title">LIABILITY_CONSTRAINTS</h2>
                    <div className="legal-text">
                        MORA TADEO SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES ARISING FROM THE USE OR INABILITY TO USE OUR SYSTEMS. BY PROCEEDING, YOU ACKNOWLEDGE THE INHERENT RISKS OF DIGITAL ARCHITECTURE.
                    </div>
                </section>

                <div className="mt-32 border-t border-white/10 pt-10">
                    <p className="legal-text opacity-40">
                        FOR LEGAL INQUIRIES: ABRAHAM@MORATADEO.COM
                    </p>
                </div>
            </div>
        </main>
    );
}
